import { Button } from '@cian/ui-kit/button';
import { Header2 } from '@cian/ui-kit/typography/Header';
import { InlineText1 } from '@cian/ui-kit/typography/InlineText';

import * as React from 'react';

import { IconOk } from '../../UI/Icons/IconOk';

import * as styles from './ModalContentStageSuccess.css';
import { IModalContentStageSuccessProps } from './types';

export const ModalContentStageSuccess: React.FC<IModalContentStageSuccessProps> = props => {
  const { onNextStage } = props;

  return (
    <div className={styles['container']}>
      <IconOk />
      <div className={styles['title-container']}>
        <Header2 as="h2" color="black_100" fontWeight="bold">
          Ваша заявка отправлена
        </Header2>
      </div>
      <InlineText1 as="span" color="black_100" fontWeight="normal">
        Наш специалист свяжется с вами в течение 2 рабочих дней
      </InlineText1>
      <div className={styles['button-container']}>
        <Button onClick={onNextStage} type="button" size="XS" theme="fill_primary">
          Хорошо
        </Button>
      </div>
    </div>
  );
};

ModalContentStageSuccess.displayName = 'ModalContentStageSuccess';
